import axios from "../services/api/api";

export const FETCH_COURSES_LIST_BEGIN = "FETCH_COURSES_LIST_BEGIN";
export const FETCH_COURSES_LIST_FULFILLED = "FETCH_COURSES_LIST_FULFILLED";
export const FETCH_COURSES_LIST_REJECTED = "FETCH_COURSES_LIST_REJECTED";
export const FETCH_SIXMONTHS_COURSES_LIST_BEGIN =
  "FETCH_SIXMONTHS_COURSES_LIST_BEGIN";
export const FETCH_SIXMONTHS_COURSES_LIST_FULFILLED =
  "FETCH_SIXMONTHS_COURSES_LIST_FULFILLED";
export const FETCH_SIXMONTHS_COURSES_LIST_REJECTED =
  "FETCH_SIXMONTHS_COURSES_LIST_REJECTED";
export const FETCH_COURSES_GRADES_BEGIN = "FETCH_COURSES_GRADES_BEGIN";
export const FETCH_COURSES_GRADES_FULFILLED = "FETCH_COURSES_GRADES_FULFILLED";
export const FETCH_COURSES_GRADES_REJECTED = "FETCH_COURSES_GRADES_REJECTED";
export const FETCH_ORPHAN_COURSES_BEGIN = "FETCH_ORPHAN_COURSES_BEGIN";
export const FETCH_ORPHAN_COURSES_FULFILLED = "FETCH_ORPHAN_COURSES_FULFILLED";
export const FETCH_ORPHAN_COURSES_REJECTED = "FETCH_ORPHAN_COURSES_REJECTED";
export function fetchCoursesForAdmin() {
  return (dispatch) => {
    dispatch({
      type: FETCH_COURSES_LIST_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get("/Course/GetAdminCourses")
          .then((response) => {
            dispatch({
              type: FETCH_COURSES_LIST_FULFILLED,
              payload: response.data.result,
            });
            resolve(true);
          })
          .catch((err) => {
            dispatch({ type: FETCH_COURSES_LIST_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}

export function fetchOrphanCoursesForAdmin() {
  return (dispatch) => {
    dispatch({
      type: FETCH_ORPHAN_COURSES_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .get("/Course/GetAdminOrphanCourses")
        .then((response) => {
          dispatch({
            type: FETCH_ORPHAN_COURSES_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_ORPHAN_COURSES_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export function fetchSlimCoursesForAdmin() {
  return (dispatch) => {
    dispatch({
      type: FETCH_SIXMONTHS_COURSES_LIST_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get("/Course/GetAdminCoursesSlim")
          .then((response) => {
            dispatch({
              type: FETCH_SIXMONTHS_COURSES_LIST_FULFILLED,
              payload: response.data.result,
            });
            resolve(true);
          })
          .catch((err) => {
            dispatch({
              type: FETCH_SIXMONTHS_COURSES_LIST_REJECTED,
              payload: err,
            });
            reject(err);
          });
      }
    });
  };
}

export function fetchCourseGradesOnlyForLastSixMonths() {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSES_GRADES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/Course/GetStudentScormModuleRatings?showOnlyLastSixMonths=true")
      .then((response) => {
        dispatch({
          type: FETCH_COURSES_GRADES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSES_GRADES_REJECTED, payload: err });
      });
  };
}

export function fetchCourseGradesForAllTime() {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSES_GRADES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/Course/GetStudentScormModuleRatings?showOnlyLastSixMonths=false")
      .then((response) => {
        dispatch({
          type: FETCH_COURSES_GRADES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSES_GRADES_REJECTED, payload: err });
      });
  };
}
